import { API_BASE_URL } from '../../config/api';
import apiCache, { CACHE_TTL } from '../../lib/apiCache';

const amateurKey = (email) => `amateur:${email}`;

// Get amateur data by email
export const getAmateur = async (email) => {
  const key = amateurKey(email);
  const cached = apiCache.get(key);
  if (cached !== undefined) return cached;

  try {
    const response = await fetch(`${API_BASE_URL}/api/amateur?email=${encodeURIComponent(email)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return apiCache.set(key, data, CACHE_TTL.USER);
  } catch (error) {
    console.error('Error fetching amateur data:', error);
    throw error;
  }
};

// Create new amateur registration
export const createAmateur = async (amateurData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/amateur/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(amateurData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    apiCache.invalidate('amateur:');
    apiCache.invalidate('amaIns:');
    return data;
  } catch (error) {
    console.error('Error creating amateur:', error);
    throw error;
  }
};

// Update amateur data
export const updateAmateur = async (amateurData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/amateur/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(amateurData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    apiCache.invalidate('amateur:');
    apiCache.invalidate('amaIns:');
    return data;
  } catch (error) {
    console.error('Error updating amateur:', error);
    throw error;
  }
};

// Delete amateur
export const deleteAmateur = async (email) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/amateur/delete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    apiCache.invalidate('amateur:');
    apiCache.invalidate('amaIns:');
    return data;
  } catch (error) {
    console.error('Error deleting amateur:', error);
    throw error;
  }
};

// Helper function to validate amateur data
export const validateAmateurData = (data) => {
  const errors = [];

  if (!data.email) errors.push('Email is required');
  if (!data.nombre) errors.push('Nombre is required');
  if (!data.apellidos) errors.push('Apellidos is required');
  if (!data.club) errors.push('Club is required');
  if (!data.sexo) errors.push('Sexo is required');
  if (!data.fnacimiento) errors.push('Fecha de Nacimiento is required');
  if (!data.curp) errors.push('CURP is required');

  return {
    isValid: errors.length === 0,
    errors
  };
};

// Helper function to format amateur data for API
export const formatAmateurData = (data) => {
  return {
    email: data.email?.trim(),
    nombre: data.nombre?.trim(),
    apellidos: data.apellidos?.trim(),
    club: data.club,
    sexo: data.sexo?.trim(),
    fnacimiento: data.fnacimiento,
    curp: data.curp?.trim(),
    telefono: data.telefono,
    celular: data.celular,
    ghin: data.ghin?.trim(),
    tipo: data.tipo?.trim(),
    handicapIndex: data.handicapIndex,
    fmg: data.fmg?.trim(),
    facebook: data.facebook?.trim(),
    instagram: data.instagram?.trim()
  };
};
